module.exports = __webpack_public_path__ + "img/hargrove-logo.6447629c.jpg";